import React from 'react';
import './App.css';
import CountDown from './componets/CountDown';
import useContDown from './hooks/useCountDown';
import noivos from './assets/IMG_8684-Editar.jpg';
import MyGallery from './componets/MyGallery';
import Local from './componets/Local';
import video from './assets/pre-wedding.mp4';
import Presentes from './componets/Presentes';
import medWhite from './assets/medWhite.png';

const App = () => {
  
  const [day, hour, minute, second] = useContDown("2024-10-19 17:00:00")

  return (
    <div className="App">
      <header id='top' className="App-header">
        <img className='noivos' src={noivos} />
        <div className='title'>
          <div>
            <img className='logoNoivos' src={medWhite} />
            <h1>Maíza e Davi</h1>
            <span className='montserrat-100'>19 de Outubro de 2024 | Campos Gerais, MG</span>
          </div>
        </div>
      </header>
      <div id='contagem-regressiva' className='Cronometro'>
        <video 
          src={video} 
          muted
          autoPlay={"autoplay"}
          preLoad="auto"
          playsinline={"playsinline"}
          loop
        />
        <div id="cronometro" className='Cronometro-div dancing-script'>
          <CountDown title="Dias" number={day} />
          <h1>:</h1>
          <CountDown title="Horas" number={hour} />
          <h1>:</h1>
          <CountDown title="Minutos" number={minute} />
          <h1>:</h1>
          <CountDown title="Segundos" number={second} />
        </div>
      </div>
      <div className='background-white'>
        <div id='nos' className='nos'>
          <div>
            <h2>Nossa história!!</h2>
            <p className='montserrat-300'>Tudo começou com um “sem querer “, uma conversa despretensiosa, com a desculpa de que ninguém queria nada. 
Mal sabíamos que Deus já havia escrito nossa história. 
Dia após o outro, fomos entendendo o motivo pelo qual nossa vida amorosa nunca deu certo rs, deu certo demais afinal. 
Nos moldamos ao decorrer dos anos pra finalmente quando estivéssemos prontos pra amar de verdade, nossas vidas se cruzassem. 
Tivemos perdas irreparáveis no decorrer desses cinco anos, que serviram pra nos mostrar o quanto precisávamos um do outro. 
E agora, perante a Deus, nossos amigos e familiares vamos eternizar nosso amor.
Um amor leve, simples e intenso, assim como o nosso é o que desejamos a vocês .</p>
          </div>
        </div>
        <Local />
        <div className='divisao-section'>
          
        </div>
        <Presentes />
        <MyGallery />
      </div>
    </div>
  );
}

export default App;
